export default [
  {
    name: 'Cadernos de Serviço',
    path: 'cadernos-servicos',
    component: () => import('@/views/parametrosComCa/cadernosServicos/Index.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { name: 'Dados', path: '/dados' },
        { name: 'Cadernos de Serviços' }
      ]
    }
  },
  {
    name: 'Cadernos de Serviço Adicionar',
    path: 'cadernos-servicos/add',
    component: () => import('@/views/parametrosComCa/cadernosServicos/Add.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { name: 'Dados', path: '/dados' },
        { name: 'Cadernos de Serviços', path: '/parametros-com-ca/cadernos-servicos' },
        { name: 'Adicionar' }
      ]
    }
  }
]